<template>
  <!-- 发送邀请 -->
  <div class="menu-item-r">
    <div class="inviteSend"> 
    <div class="inviteSendBg" ref="inviteSendBg">
      <!-- <div class="inviteSendBg_t"></div> -->
      <img class="inviteSendBg_t" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/invitation-up-chun.png">
      <div class="inviteSendBg_main">
        <h3 class="inviteSendBg_main_h3">{{$t('尊敬的顾客')}}</h3>
        <p class="inviteSendBg_main_p">{{$t('邀请函提示内容')}}
        <h4 class="inviteSendBg_main_h4 m-b-12" style="margin-top: 52px;">{{$t('公司名称')}}</h4>
        <h4 class="inviteSendBg_main_h4" style="font-size: 26px; margin-bottom: 60px;">
          {{(this.info.exhibitorEmployee && this.info.exhibitorEmployee.exhibitor) ? this.language === 'en' ? (this.info.exhibitorEmployee.exhibitor.enName || this.info.exhibitorEmployee.exhibitor.name || '--') : (this.info.exhibitorEmployee.exhibitor.name || this.info.exhibitorEmployee.exhibitor.enName || '--') : '--'}}</h4>
        <div class="inviteSendBg_main_p2" style="margin-bottom: 20px;">
            <p style="margin-bottom: 8px;">{{$t('提示')}}</p>
            {{$t('提示信息')}}
        </div>
        <p class="m-b-12">   
          <span class="tipSpan"></span><strong>{{ $t('Latest Products') }}</strong>
        </p>
        <div class="txt-notice">
          <div class="m-b-12">
              <div class="m-b-5"><i class="el-icon-warning"></i>&nbsp;&nbsp;{{ $t('exhformTisp') }}{{ $t('Latest Products Tips1') }}；</div>
              <div class="m-b-5 m-l-51">{{ $t('Latest Products Tips2') }}；</div>
              <div class="m-b-5 m-l-51">{{ $t('Latest Products Tips3') }}；</div>
          </div>
        </div>
        <el-button 
          type="primary"
          size="medium"
          class="font-size-13 margin-tb-12"
          icon="el-icon-circle-plus-outline" 
          @click="uploadFile()" 
          :disabled="inviteProuncts.length >= 6"
          >
          {{$t('Upload exhibits')}}
        </el-button>
        <div class="scene-container" :class="{'margin-t-24': (inviteProuncts.length > 0 ) }">
          <!-- 关联展品 弹窗 -->
          <div ref="inviteProuncts" class="inviteProuncts_box" v-if="inviteProuncts.length!=0">
            <div class="inviteProuncts_div" v-for="(item,index) in inviteProuncts" :key="index">
              <img class="inviteProuncts_img" :src="getImgSrc(item.iconUrl)">
              <div class="inviteProuncts_operation">
                <span class="inviteProuncts_upload goback font-size-14 theme-color" @click="uploadFile()">{{ $t('Upload again') }}</span>
                <span class="goback font-size-14 theme-color" @click="del(inviteProuncts,index)">{{ $t('del') }}</span>
              </div>
            </div>
          </div>
          <selectProduct
              ref="sel"
              @sure="combineProduct"
              @cancel="cancel"
              @current-change="handleCurrentChange"
              :multiple="true"
              :productArr.sync='productArr'
              :dialogShow.sync="showCombination"
              :productId.sync="productId"
          ></selectProduct>
        </div>
      </div>
       <img class="inviteSendBg_down" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/invitation-down-chun.png">
    </div>
    </div>
    <div class='inviteSend2'>
    <div class="inviteSend_info p-16 p-b-0">
      <p class="color-b4 m-b-12">{{ $t('inviteSendTips') }}</p>

      <el-row type="flex" class="row-bg p-16 m-b-16" justify="space-between"  v-for="(item,index) in infoObj" :key="index">
        <el-col :span="6">
          <p class="margin-b-8">{{ $t('name') }}<p/>
          <el-input size="medium" v-model="item.name" :placeholder="$t('Please type something...')"></el-input>
        </el-col>
        <el-col :span="6">
          <p class="margin-b-8">{{ $t('email') }}<p/>
          <el-input size="medium" v-model="item.email" :placeholder="$t('Please type something...')"></el-input>
        </el-col>
        <el-col :span="6" style="margin-top: 31px; text-align: right">
          <el-button 
            type="primary"
            size="medium"
            icon="el-icon-circle-plus-outline"
            class="font-size-13"
            @click="appedList()"
            >
            {{ $t('Add') }}
          </el-button>
          <el-button 
            v-if="showOutline"
            type="danger"
            size="medium"
            icon="el-icon-delete"
            class="font-size-13"
            @click="removeList(index)"
            >
            {{ $t('del') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="inviteSend_info p-16 p-t-0">
      
      <div class="button-group">
        <p class="m-b-12">
        <strong>{{ $t('Upload file') }}</strong>
      </p>
        <div class="m-b-12 font-size-12 color-b4"><i class="el-icon-warning"></i>&nbsp;&nbsp;{{ $t('exhformTisp') }}{{ $t('Latest Products Tips4') }}；</div>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-circle-plus-outline"
          class="font-size-13 margin-tb-12"
          :disabled="infoArr.length>0"
          @click="uploadFile1('uploadImg')"
        >{{ $t('Upload file') }}</el-button>
      </div>
      <div class="image-list1">
        <div class="upload-image-container" :class="{'margin-t-24': infoArr.length > 0}">
          <DashUploadMoreAll
            ref="uploadImg"
            size="exhinfo"
            :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'"
            :uploadBtn="false"
            :editFailName="false"
            :limit="1"
            :fileUrl.sync="infoArr"
            types="inviteSend"
          ></DashUploadMoreAll>
        </div>
      </div>

    </div>

    <div class="text-right p-24">
      <div>
        <p
          style="width:80%;display: inline-block;text-align: left;font-weight: bold;"
          >
          {{this.linkUrl}}
        </p>
        <el-button 
          size="medium"
          class="font-size-13"
          @click="copyLink()"
          >
          {{ $t('Generate Link') }}
        </el-button>
      </div>
      <div>
        <el-button 
            type="primary"
            size="medium"
            icon="el-icon-circle-plus-outline"
            class="font-size-13"
            :loading="submitLoading"
            @click="sendOut()"
            >
            {{ $t('sendOut') }}
          </el-button>
          <el-button 
            size="medium"
            @click="downloadTemplate()"
            class="font-size-13"
            >
            {{ $t('downloadTemplate') }}
          </el-button>
          <!-- <el-button 
            size="medium"
            class="font-size-13"
            @click="copyLink()"
            >
            {{ $t('Copy Link') }}
          </el-button> -->
      </div>
      
    </div>
    <div class="inviteSendBgshow" ref="inviteSendBg1">
      <div class="inviteSend">
        <div class="inviteSendBg">
          <img class="inviteSendBg_t" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/invitation-up-chun.png">
          <div class="inviteSendBg_main">
            <h3 class="inviteSendBg_main_h3">{{$t('尊敬的')}} ${NAME}</h3>
            <p class="inviteSendBg_main_p">{{$t('邀请函提示内容')}}
            <h4 class="inviteSendBg_main_h4" style="margin-top: 52px;margin-bottom: 12px;">{{$t('公司名称')}}</h4>
            <a target="_blank" :href="getURL('actor')" class="inviteSendBg_main_h4" style="display:block;font-size: 26px;margin-bottom: 60px;margin-top: 0;font-weight:bold;text-decoration: none;">{{this.info.exhibitorEmployee.exhibitor.enName || this.info.exhibitorEmployee.exhibitor.name}}</a>
            <div style="margin-bottom: 20px;font-size: 14px;line-height: 1.444;color: rgba(0,0,0,.45)">
                <p style="margin-bottom: 8px;">{{$t('提示')}}</p>
                {{$t('提示信息')}}
            </div>
            <p class="m-b-12"><span class="tipSpan"></span><strong>{{ $t('Latest Products') }}</strong></p>
            <div class="scene-container" :class="{'margin-t-24': (previewImageUrl.length > 0 ) }">
              <div ref="inviteProuncts" class="inviteProuncts_box" v-if="inviteProuncts.length!=0">
                <div class="inviteProuncts_div" v-for="(item,index) in inviteProuncts" :key="index">
                  <a target="_blank" :href="getURL('product', item)"><img class="inviteProuncts_img" :src="getImgSrc(item.iconUrl)"></a>
                </div>
              </div>
              <div class="ViewMore">
                <a target="_blank" :href="getURL('actor')">{{$t('查看更多')}}</a>
              </div>
            </div>
          </div>
          <img class="inviteSendBg_down" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/invitation-down-chun.png">
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import selectProduct from '@/components/dialog/selectProduct'
import { deepClone } from '@/utils/function'
import DashUploadMoreAll from '@/components/DashUploadMoreAll'

import { 
  sendEmail,
  saveEmail,
  addRecord,
  importEmail
} from '@/api/index'
export default {
  data () {
    return {
      linkUrl:'',
      dropActive:false,
      infoArr: '',
      uploadFileStatus: 1,
      loading: false,
      previewImageUrl: [],
      infoObj: [
        {
          name: '',
          email: ''
        }
      ],
      showOutline: false,
      inviteProuncts: [],
      currentHotspot: null,
      showCombination: false,
      productId: [],
      productArr: [],
      currentProduct: {},
      submitLoading: false
    }
  },
  components: {
    selectProduct,
    DashUploadMoreAll,
  },
  mounted () {},
  computed: {
    ...mapGetters(['language', 'subjectType', 'info', 'exhibitorId', 'exhibitionId'])
  },
  watch: {
    'infoArr':  {
        handler: function() {
          this.uploadFileInfo(this.infoArr)
          // if(typeof this.infoArr[0] == 'object') {
          //   if(this.infoArr[0]['data'].length>0) {
          //     this.infoObj = this.infoArr[0]['data']
          //     this.showOutline = true
          //   }
          // }
          // if(typeof this.infoArr[0] == 'undefined') {
          //   this.infoObj = [
          //     {
          //       name: '',
          //       email: ''
          //     }
          //   ]
          //   this.showOutline = false
          // }
        }
    }
  },
  methods: {
    fn(arr) {
        return arr.reduce((prev,cur)=>{
            return prev.concat(Array.isArray(cur)?this.fn(cur):cur)
        }, [])
    },
    flattenDeep(arrs) {
      let result = Array.prototype.concat.apply([], arrs);
      while (result.some(item => item instanceof Array)) {
        result = Array.prototype.concat.apply([], result);
      }
      return result;
    },
    uploadFileInfo(url) {
      let params = {
        ossUrl: url
      }
      importEmail(params).then((res) => {
        this.infoObj = res.data.data || []
      })
    },
    copyLink() {
      if (this.inviteProuncts.length === 0) {
        this.$notify.error({
          title: this.$t('tips'),
          message: this.$t('Please select at least one exhibit')
        });
        return false
      }
      var sendInnerHTML = this.$refs.inviteSendBg1.innerHTML
      var cName = (this.info && this.info.exhibitorEmployee && this.info.exhibitorEmployee.exhibitor) ? this.language === 'en' ? (this.info.exhibitorEmployee.exhibitor.enName || this.info.exhibitorEmployee.exhibitor.name|| '') : (this.info.exhibitorEmployee.exhibitor.name || this.info.exhibitorEmployee.exhibitor.enName || '') : ''
      var sendHtml = '<!DOCTYPE html><head><meta charset="utf-8" /><meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"><title>'+(cName || 'Invitation')+'</title><meta name="viewport" content="width=device-width, initial-scale=1.0"><style type="text/css">*{padding:0;margin:0}.inviteSend {width: 1120px;margin: auto}.inviteSendBg {background: #133781;}.tipSpan {display: inline-block;width: 4px;height: 13px;background: #0D2863;margin-right: 8px;}.inviteSendBg_t {width:100%;}.inviteSendBg_down{width:100%;margin-top:-400px}.inviteSendBg_main {width: 52%;background: rgba(255,255,255,0.5);box-shadow: 0px 8px 29px 5px rgba(0,0,0,0);border-radius: 8px;margin: 20px auto 0;padding: 25px 10%;position: relative;}.inviteSendBg_main .inviteSendBg_main_h3 {height: 30px;font-size: 22px;font-weight: 500;color: #000;line-height: 30px;}.inviteSendBg_main .inviteSendBg_main_p {padding-bottom: 8px;font-size: 20px;font-weight: 400;color: #666;line-height: 40px;text-align: justify;margin-top: 8px;}.inviteSendBg .inviteSendBg_main .inviteSendBg_main_h4 {width: 100%;font-size: 32px;text-align: center;font-weight: 600;color: #0D2863;line-height: 45px;}.row-bg {background: #fff;}.inviteSend_info {background: #fbfbfb;}.inviteProuncts_box {display: flex;flex-wrap: wrap;}.inviteProuncts_div {width: 182px;height: 182px;border: 1px solid #e5e5e5;margin: 5px 5px 5px 5px;}.inviteProuncts_div a {width: 182px;height: 182px;display: inline-block;}.inviteProuncts_img {width: 182px;height: 182px;object-fit: cover;}.inviteProuncts_operation {text-align: right;}.inviteProuncts_upload {margin-right: 5px;}.ViewMore {width: 100%;height: 40px;line-height: 40px;background: #0D2863;text-align: center;border-radius: 5px;color: #fff;margin: 30px auto;}.button-group {background: #fff;padding: 15px;}.el-icon-warning {color: #faad14;}.m-b-5 {color: #0D2863;font-size: 12px;font-weight: 400;line-height: 17px;}.m-l-51 {margin-left: 51px;}.ViewMore a{width:100%; height:100%;color:#fff;display: inline-block;text-decoration: none !important;}  @media screen and (max-width: 750px) {body html {margin:0px;padding:0px;}.inviteSend{width: 100%;}.inviteSendBg_main {width: 72%;padding: 25px 8%;}.inviteProuncts_box{justify-content: center;}.inviteProuncts_div{margin: 5px 5px 5px 5px;}}</style></head><body>'+ sendInnerHTML +'</body></html>'
      let params = {
        sends: [{name: 'Customer',email: 'Customer@test.com'}],
        content: sendHtml,
        host: window.location.origin + '/share/'
      }
      saveEmail(params).then(res => {
        if(res.data.code == 1000) {
          this.linkUrl = res.data.data
          this.onCopy()
        } 
      })
      
      
    },
    copyText(text, callback){ // text: 要复制的内容， callback: 回调
      var tag = document.createElement('input');
      tag.setAttribute('id', 'cp_hgz_input');
      tag.value = text;
      document.getElementsByTagName('body')[0].appendChild(tag);
      document.getElementById('cp_hgz_input').select();
      document.execCommand('copy');
      document.getElementById('cp_hgz_input').remove();
      if(callback) {callback(text)}
    },
    getURL(type, data) {
        let str = window.location.origin
        let exhibitorEmployee = this.info.exhibitorEmployee || {}
        let params = '?userAccountId=' + exhibitorEmployee.userAccountId + '&exhibitorId=' + exhibitorEmployee.exhibitorId + '&email=${EMAIL}'

        if (type === 'actor') {
            str += '/find-exhibitor/detail/' + exhibitorEmployee.exhibitorId
        } else if (type === 'product') {
            str += '/find-exhibit/detail/' + data.productId
        }
        str += params
        return str
    },
    getImgSrc(imgs) {
        if (!imgs) return imgs
        imgs = imgs.split(",")
        return imgs[0]
    },
    // 文件上传功能
    uploadFile1(name, status) {
      if (status !== undefined) {
        this.uploadFileStatus = status
      }

      if (status === 1 ) {
        return
      }

      this.$nextTick(() => {
        this.$refs[name].uploadAdd()
      })
    },
    uploadFile() {
      this.showCombination = true
    },
    combineProduct(cb) {
      var inviteProuncts = deepClone(this.productArr)
      this.inviteProuncts = inviteProuncts
      cb()
    },
    handleCurrentChange(val,o) {
      this.productArr = o
      if (val) {
        this.currentProduct = val
      }
    },
    cancel() {},

    del(inviteProuncts,index) {
      this.productArr.splice(index,1)
      this.productId.splice(index,1)
      this.$refs.sel.ids.splice(index,1)
      this.inviteProuncts.splice(index,1)
    },
    appedList() {
      this.infoObj.push({
        name: '',
        email: ''
      })
      this.showOutline = true
    },
    removeList (index) {
      this.infoObj.splice(index, 1)
      for (let i in this.infoObj) {
        this.infoObj[i].index = i
      }
      if (this.infoObj.length > 1) {
        this.showOutline = true
      } else {
        this.showOutline = false
      }
    },
    // 发送
    sendOut() {
      if (this.inviteProuncts.length === 0) {
        this.$notify.error({
          title: this.$t('tips'),
          message: this.$t('Please select at least one exhibit')
        });
        return false
      }
      
      var flag1
      var infoObj1 = []
      for (var item of this.infoObj) {
        if (!Object.values(item).some(v => v === '')) {
          flag1 = true
          infoObj1.push(item)
        }
      }
      if(!flag1) {
        this.$notify.error({
          title: this.$t('tips'),
          message: this.$t('Please enter the information of the invitee')
        });
        return false
      }
      
      this.submitLoading = true
      var sendInnerHTML = this.$refs.inviteSendBg1.innerHTML
      var cName = (this.info && this.info.exhibitorEmployee && this.info.exhibitorEmployee.exhibitor) ? this.language === 'en' ? (this.info.exhibitorEmployee.exhibitor.enName || this.info.exhibitorEmployee.exhibitor.name || '--') : (this.info.exhibitorEmployee.exhibitor.name || this.info.exhibitorEmployee.exhibitor.enName || '--') : ''
      var sendHtml = '<!DOCTYPE html><head><meta charset="utf-8" /><meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"><title>'+(cName || 'Invitation')+'</title><meta name="viewport" content="width=device-width, initial-scale=1.0"><style type="text/css">*{padding:0;margin:0}.inviteSend {width: 1120px;margin: auto}.inviteSendBg {background: #133781;}.tipSpan {display: inline-block;width: 4px;height: 13px;background: #0D2863;margin-right: 8px;}.inviteSendBg_t {width:100%;}.inviteSendBg_down{width:100%;margin-top:-400px}.inviteSendBg_main {width: 55%;background: rgba(255,255,255,0.5);box-shadow: 0px 8px 29px 5px rgba(0,0,0,0);border-radius: 8px;margin: 20px auto 0;padding: 25px 10%;position: relative;}.inviteSendBg_main .inviteSendBg_main_h3 {height: 30px;font-size: 22px;font-weight: 500;color: #000;line-height: 30px;}.inviteSendBg_main .inviteSendBg_main_p {padding-bottom: 8px;font-size: 20px;font-weight: 400;color: #666;line-height: 28px;text-align: justify;}.inviteSendBg .inviteSendBg_main .inviteSendBg_main_h4 {width: 100%;font-size: 32px;text-align: center;font-weight: 600;color: #0D2863;line-height: 45px;}.row-bg {background: #fff;}.inviteSend_info {background: #fbfbfb;}.inviteProuncts_box {display: flex;flex-wrap: wrap;}.inviteProuncts_div {width: 182px;height: 182px;border: 1px solid #e5e5e5;margin: 5px 5px 5px 5px;}.inviteProuncts_div a {width: 182px;height: 182px;display: inline-block;}.inviteProuncts_img {width: 182px;height: 182px;object-fit: cover;}.inviteProuncts_operation {text-align: right;}.inviteProuncts_upload {margin-right: 5px;}.ViewMore {width: 100%;height: 40px;line-height: 40px;background: #0D2863;text-align: center;border-radius: 5px;color: #fff;margin: 30px auto;}.button-group {background: #fff;padding: 15px;}.el-icon-warning {color: #faad14;}.m-b-5 {color: #0D2863;font-size: 12px;font-weight: 400;line-height: 17px;}.m-l-51 {margin-left: 51px;}.ViewMore a{width:100%; height:100%;color:#fff;display: inline-block;text-decoration: none !important;}  @media screen and (max-width: 750px) {body html {margin:0px;padding:0px;}.inviteSend{width: 100%;}.inviteSendBg_main {width: 72%;padding: 25px 8%;}.inviteProuncts_box{justify-content: center;}.inviteProuncts_div{margin: 5px 5px 5px 5px;}}</style></head><body>'+ sendInnerHTML +'</body></html>'
      let params = {
        sends: infoObj1,
        content: sendHtml,
        host: window.location.origin + '/share/'
      }

      sendEmail(params).then(res => {
        if(res.data.code == 1000) {
          this.$notify({
            message: this.$t('tip.success'),
            type: 'success'
          });

          addRecord({
            exhibitionId: this.exhibitionId,
            exhibitorId: this.exhibitorId,
            userAccountId: this.info.userAccountId,
            batchData: params.sends
          })
        } 
      }).finally(() => {
        this.submitLoading = false
      })

    },
    //
    downloadTemplate() {
      window.location.href='https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_record/%E9%82%80%E8%AF%B7%E5%87%BD%E6%8E%A5%E5%8F%97%E4%BA%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
    },
    //
    onCopy() {
      this.$notify({
        title: this.$t('tip.success'),
        type: 'success'
      })
    },
    
  }
}
</script>
<style lang="stylus">
  .inviteSend {
    margin: 30px auto 16px;
    padding: 15px;
    background: $color-gray-fb;
  }
  .inviteSend2 {
    margin-bottom: 30px;
    background: $color-gray-fb;
  }
  .tipSpan{
    display: inline-block;
    width: 4px;
    height: 13px;
    background: $color-main;
    margin-right: 8px;
  }
  .inviteSendBg{
    background: $color-green-D4E;
  }
  .inviteSendBg_t{
    width:100%;
    height 258px
  }
  .inviteSendBg_down{
    width:100%;
    margin-top: -400px;
  }

  .inviteSendBg_main{
    width 66%
    // min-height 1023px
    background: $color-white-50 ;
    box-shadow: 0px 8px 29px 5px $color-black-00;
    border-radius: 8px;
    margin: 20px auto 0;
    padding: 25px 8%;
    position: relative;
  }
    
  .inviteSendBg_main_h3{
    min-height: 30px;
    font-size: 22px;

    font-weight: 500;
    color: $color-black;
    line-height: 30px;
  }
  .inviteSendBg_main_p{
    margin-top: 8px;
    font-size: 20px;
    font-weight: 400;
    color: $color-gray-66;
    line-height: 28px;
    text-align: justify;
  }
  .inviteSendBg_main_p2{
    font-size: 14px;
    line-height: 1.444;
    color: $color-gray-45;
  }
  .inviteSendBg_main_h4{
    width: 100%;
    min-height: 45px;
    font-size: 32px;
    text-align: center;
    font-weight: 600;
    color: $color-green-037;
    line-height: 45px;
  }
  .inviteSend .row-bg,
  .inviteSend2 .row-bg{
    background $color-white  
  }
  .inviteSend .inviteSend_info,
  .inviteSend2 .inviteSend_info{
    background $color-gray-fb
  }
  .inviteProuncts_box{
    display: flex;
    flex-wrap: wrap;
  }
  .inviteProuncts_div{
    width: 176px;
    height: 176px;
    border: 1px solid $color-gray-e5;
    margin: 5px 5px 35px 0px;
  }
  .inviteProuncts_div a{
    width: 176px
    height: 176px;
    display: inline-block; 
  }
  .inviteProuncts_img{
    width: 100%;
    height: 100%;
    margin-bottom: 8px;
    object-fit: cover;
  }
  .inviteProuncts_operation{
    text-align:right;
  }
  .inviteProuncts_upload{
    margin-right: 5px;  
  }
  .ViewMore {
    width: 80%;
    height: 40px;
    line-height: 40px;
    background: $color-main;
    text-align: center;
    border-radius: 5px;
    color:$color-white;
    margin: 30px auto;
  }
  .ViewMore a{
    width:100%; 
    height:100%;
    color:$color-white;display: inline-block;}
  
  .button-group{
    background: $color-white;
    padding: 15px;
  }

  .el-icon-warning{
    color:$color-headImg-tips
  }
  .m-b-5{
    color:$color-red-b4;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
  }
  .color-b4{
    color:$color-red-b4;
  }
  .m-l-51{
    margin-left 51px;
  }

  .inviteSendBgshow{
    display none
  }
</style>